<template>
  <div class="image-container">
    <img :src="this.imgSrc" class="responsive-image"> <!--  -->
  </div>
</template>

<script>
  import axios from "axios";
  import ajax from "../../api/ajax";
  import api from "../../api/url";
  import cookie from "../../api/cookie";

  export default {
    name: "PreviewImgFile",
    data() {
      return {
        imgSrc:'',
        imgName:'',
      };
    },
    mounted() {
      // 获取url参数
      let filePath = this.$route.query.filePath;
      if(filePath.length > 0){
        // 请求图片流
        axios.get(ajax.ajaxUrl()+api.PREVIEWIMGFILE, {
          params: { filePath: encodeURIComponent(filePath) },
          headers: {
            Authorization: cookie.getBearerToken()
          },
          responseType: 'blob' // 重要：告诉axios期望接收二进制数据
        }).then(response => {
          const contentType = response.headers['content-type'] || 'image/jpeg';
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          this.imgSrc = url;
          this.imgName = filePath.split('/').pop();

          this.$once('hook:beforeDestroy', () => {
            window.URL.revokeObjectURL(url);
          });
        });
      }
    },
    methods: {
      async handleRightClick(e) {
        e.preventDefault(); // 阻止默认右键菜单

        const blobUrl = this.imgUrl;

        const response = await fetch(blobUrl);
        const blob = await response.blob();

        const filename = this.imgName;

        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename; // 强制使用指定文件名
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }, 100);
      },
    }
  };
</script>

<style lang="less" scoped>
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* 使用视口高度单位，占屏幕高度的70% */
    width: 100%;
    background-color: black; /* 添加黑色背景 */
    border: 1px solid #ddd;
    overflow: hidden; /* 防止内容溢出 */
  }

  .responsive-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; /* 保持图片比例完整显示 */
  }
</style>